import Area from '@/components/Area';
import { Canvas } from '@react-three/fiber';
import * as React from 'react';
import * as THREE from 'three';

function Walls() {
  const [points, setPoints] = React.useState<THREE.Vector3[]>([]);
  const linePoints = React.useMemo(() => {
    const pts: Float32Array[] = [];
    for (let i = 1; i < points.length; i++) {
      const [prev, next] = points.slice(i - 1, i + 1);
      pts.push(new Float32Array([prev.x, prev.y, prev.z, next.x, next.y, next.z]));
    }
    return pts;
  }, [points]);

  const refMoving = React.useRef<THREE.Vector3 | null>(null);
  const bufferGeometry = React.useMemo(() => new THREE.BufferGeometry(), []);

  return (
    <>
      <mesh
        onPointerDown={(e) => {
          const [intersection] = e.intersections;
          if (intersection) {
            const point = intersection.point;
            setPoints((prev) => [...prev, point]);
          }
        }}
        onPointerMove={(e) => {
          refMoving.current = e.point;
          if (points.length) {
            const lastPoint = points[points.length - 1];
            bufferGeometry.setFromPoints([lastPoint, e.point]);
          }
        }}
      >
        <planeGeometry args={[100, 100]} />
        <meshBasicMaterial color={0xcccccc} side={THREE.DoubleSide} />
      </mesh>
      {linePoints.map((array, index) => (
        <line key={index}>
          <bufferGeometry>
            <bufferAttribute attach="attributes-position" array={array} count={2} itemSize={3} />
          </bufferGeometry>
          <lineBasicMaterial color="red" />
        </line>
      ))}
      <line>
        <bufferGeometry attach="geometry" {...bufferGeometry} />
        <lineBasicMaterial color="blue" />
      </line>
    </>
  );
}

export type Props = {};

function App01(props: Props) {
  const {} = props;
  // useFrame(() => {
  //   //
  // });

  return (
    <Area css={{ position: 'relative' }}>
      {(el) => (
        <Canvas
          eventSource={el}
          camera={{
            position: [0, 5, 10],
            fov: 75,
            // lookAt: [0, 0, 0]
          }}
        >
          <ambientLight intensity={0.5} />
          <Walls />
          {/* <OrbitControls /> */}
        </Canvas>
      )}
    </Area>
  );
}

export default React.memo(App01);
